import { FILTER_PAGE } from './constants'

const initialState = {
  date: '',
  event: null,
}

export const getFilterPage = (state = initialState, action) => {
  switch (action.type) {
    case FILTER_PAGE:
      return {
        ...state,
        page: action.page,
        event: action.event,
      }
    default:
      return state
  }
}
